export const SESSION_PARAM = 'session';
export const ARTIFACT_PARAM = 'artifact';

const ARTIFACT_PAGE_ROUTE = '#/react/artifacts';

const CONTENT_URL_RE = /^artifacts\/([^/]+)\/([^/]+)$/;

export const parseArtifactContentUrl = contentUrl => {
    const match = CONTENT_URL_RE.exec(contentUrl || '');
    if (!match) return null;
    return { sessionId: match[1], artifactId: match[2] };
};

export const artifactPagePath = contentUrl => {
    const parsed = parseArtifactContentUrl(contentUrl);
    if (!parsed) return null;

    const params = new URLSearchParams({ [SESSION_PARAM]: parsed.sessionId, [ARTIFACT_PARAM]: parsed.artifactId });
    return `${ARTIFACT_PAGE_ROUTE}?${params}`;
};

export const artifactContentUrl = (sessionId, artifactId) => `artifacts/${sessionId}/${artifactId}`;
